import { render, staticRenderFns } from "./VoronoiVisualizer.vue?vue&type=template&id=2728a10b&"
import script from "./VoronoiVisualizer.vue?vue&type=script&lang=js&"
export * from "./VoronoiVisualizer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VoronoiVisualizer.vue"
export default component.exports